
export const name = "MeetingsPublic";
export const version = "dev";
